export default "__VITE_ASSET__C5AxqtGq__"